/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentInfo
 */
export interface DocumentInfo {
    /**
     * 
     * @type {string}
     * @memberof DocumentInfo
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentInfo
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentInfo
     */
    isFolder: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentInfo
     */
    parentId: string | null;
    /**
     * 
     * @type {Array<DocumentInfo>}
     * @memberof DocumentInfo
     */
    children: Array<DocumentInfo> | null;
    /**
     * 
     * @type {any}
     * @memberof DocumentInfo
     */
    size: any | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentInfo
     */
    extension: string;
    /**
     * 
     * @type {string}
     * @memberof DocumentInfo
     */
    version: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentInfo
     */
    createdOn: Date | null;
}

/**
 * Check if a given object implements the DocumentInfo interface.
 */
export function instanceOfDocumentInfo(value: object): value is DocumentInfo {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('isFolder' in value) || value['isFolder'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    if (!('children' in value) || value['children'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('extension' in value) || value['extension'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('createdOn' in value) || value['createdOn'] === undefined) return false;
    return true;
}

export function DocumentInfoFromJSON(json: any): DocumentInfo {
    return DocumentInfoFromJSONTyped(json, false);
}

export function DocumentInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'isFolder': json['isFolder'],
        'parentId': json['parentId'],
        'children': (json['children'] == null ? null : (json['children'] as Array<any>).map(DocumentInfoFromJSON)),
        'size': json['size'],
        'extension': json['extension'],
        'version': json['version'],
        'createdOn': (json['createdOn'] == null ? null : new Date(json['createdOn'])),
    };
}

export function DocumentInfoToJSON(value?: DocumentInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'isFolder': value['isFolder'],
        'parentId': value['parentId'],
        'children': (value['children'] == null ? null : (value['children'] as Array<any>).map(DocumentInfoToJSON)),
        'size': value['size'],
        'extension': value['extension'],
        'version': value['version'],
        'createdOn': (value['createdOn'] == null ? null : (value['createdOn'] as any).toISOString()),
    };
}

